// extracted by mini-css-extract-plugin
module.exports = {"back-button-container":"PaymentAndDelivery_back-button-container__ptdlB"};